//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Field } from 'redux-form'

//phoenix react lib components
import ContainerRowReduxTextField from '@lesofi/phoenix-react-js/lib/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '@lesofi/phoenix-react-js/lib/ContainerRowReduxCheckboxField'
import ContainerRowError from '@lesofi/phoenix-react-js/lib/ContainerRowError'
import PhTextField from '@lesofi/phoenix-react-js/lib/PhTextField'
import AutoSuggestInput from '@lesofi/phoenix-react-js/lib/AutoSuggestInput'
import ContainerOverrideReduxField from '@lesofi/phoenix-react-js/lib/ContainerOverrideReduxField'

import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import ContainerRowReduxReadonlyTextAndOverrideField from '../ProjectDemeter/common/ContainerRowReduxReadonlyTextAndOverrideField'

import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/genericFlowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

import * as actions from '../../redux/athena/actions';

const refreshTotalAmount=(props:InvoiceHeaderForm$Props)=>{
    const { athena,isOverrideTotal } = props;
    
    if (!isOverrideTotal){
        let total = (athena.totalSumOfItemAmount:any);
        if (total){
            total = parseFloat(total)
            const changeFieldValue = (props.changeFieldValue:any)
            changeFieldValue('total',total.toFixed(2))
        }
    }
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const athena:ReducerState$Type = (props.athena:any)
    
    if (isInvalidDoc && Object.keys(athena.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        const arr:Array<mixed> = (athena.lineItems:any)
        if (arr.length > 0 && Object.keys(athena.formError).length == 0) {
            return (
                <div>
                    <button type="button" onClick={()=> submitOpenActionDialog()} 
                    className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
                </div>    
            )
        }
    }
}

const autoCompleteDataSourceConfig = {
    text: "vendorName",
    value: "vendorName"
}

const styles = {
    textFieldStyle: {
        width: '310px',
        paddingBottom: '10px'
    }
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, athena } = this.props
        if (!athena.vendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt);
        }
    }
    
    componentDidUpdate(){
        refreshTotalAmount(this.props)
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,athena,isInvalidDoc,actConfDialog,jwt,taskAcceptedInfoId,isOverrideVendorName,isOverrideTotal,vendorName} = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
        
        if (athena.invoiceSubmitted) {
            return <Redirect to='/projectAthena/submittedForm' />;
        }

        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerOverrideReduxField 
                    changeFieldValue={changeFieldValue} checkboxField={'isOverrideVendorName'} 
                    checkboxLabel={'Override this Vendor Name field'} childrenField={'vendorName'}  >
                    {!isOverrideVendorName?(
                        <Field 
                            name={'vendorName'}
                            component={AutoSuggestInput}
                            datas={athena.vendors}
                            placeholder={'Type vendor name'} 
                            valueField={'vendorName'}
                        />
                    ):(
                        <Field
                            name={'vendorName'}
                            component={PhTextField}
                            label={'Vendor Name'}
                            style={styles.textFieldStyle}
                        />
                    )}
                </ContainerOverrideReduxField>

                <ContainerRowReduxTextField field={'invNo'} label={'Invoice Number'} />
                <ContainerRowReduxTextField field={'invDate'} label={'Invoice Date'} />
                <ContainerRowReduxTextField field={'bookingNo'} label={'Booking Number'} />
                <ContainerRowReduxTextField field={'referenceNo'} label={'Reference Number'} />
                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'total'} textLabel={'Total'} textType={'number'}
                    checkboxField={'isOverrideTotal'} checkboxLabel={'Override this Total field'}
                    isOverride={isOverrideTotal} notOverrideFunc={refreshTotalAmount} 
                    parentProps={this.props}
                />
                <ContainerRowError errorMsg={athena.error} />
            
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        athena: state.athena,
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideVendorName: selector(state, 'isOverrideVendorName'),
        isOverrideTotal: selector(state, 'isOverrideTotal'),
        total: selector(state, 'total'),
        vendorName: selector(state, 'vendorName')
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.athena, jwt, taskAcceptedInfoId))  
      },
      populateVendorsList: (jwt:string)=>{
        dispatch(actions.populateVendorsList(jwt))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/projectAthena/InvoiceHeaderForm.js